import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'app/lib/api.service';
import { LogService } from 'app/lib/log.service';
import { ModalService } from 'app/lib/modal.service';
import { StorageService } from 'app/lib/storage.service';
import { CreatePermissionComponent } from 'app/components/create-permission/create-permission.component'
import { AnalyticEvent } from 'app/lib/analytic-event';
@Component({
    selector: 'app-system-permission',
    templateUrl: './system-permission.component.html',
    styleUrls: ['./system-permission.component.scss'],
    standalone: false
})
export class SystemPermissionComponent implements OnInit {
  isLoaded:boolean = false;
  roles: Array<Object> = [];
  permission:Array<Object> = [];
  permissionSelected= [];
  allPermission=[];
  permissionDataToSave= [];
  constructor(
		private api: ApiService,
    private log: LogService,
    private modalService: ModalService,
    private router: Router,
    private storage: StorageService) {

    const user = this.storage.get('user', true);
    if (user?.userType !== 'superadmin') {
        this.router.navigate(['/app']);
        return;
    }

    this.getAllRoles();
    this.getAllPermissions();
    }

  ngOnInit(): void {
  }

  // Get All Permissions
  getAllPermissions(){
    this.isLoaded = true;
    this.api.get(`getpermissions`).subscribe(
			(results: any) => {
        this.isLoaded = false;
        this.permission = results;
        this.getAllRoleAndPermissions();
			},
			(error: any) => {
				this.log.error('Error loading. ' + error.message);
				this.isLoaded = false;
			}
		);
  }


   // Get All Roles
   getAllRoles(){
    this.api.get(`getroles`).subscribe(
			(results: any) => {
      this.roles = results;
      this.isLoaded = false;
			},
			(error: any) => {
				this.log.error('Error loading. ' + error.message);
				this.isLoaded = false;
			}
		);
  }


  // Get All Permissions
  getAllRoleAndPermissions(){
    this.api.get(`getallpermissions`).subscribe(
			(results: any) => {
        results.filter(results =>{
          results['PermissionName'] = this.permission.find(perm => perm['ID'] === results.PermissionID)?.['Name'];
        });
      this.allPermission = this.groupByCategory(results);
      this.setSelectOrDeselectCheckbox();
			},
			(error: any) => {
				this.log.error('Error loading. ' + error.message);
				this.isLoaded = false;
			}
		);
  }

  groupByCategory(data){
    let formattedArray = [];
    this.permission.forEach((element,index) => { 
      const permissinonExistArray = data.filter(allPerms =>allPerms.PermissionID === element['ID']);
      if (permissinonExistArray.length === 0) {
        let noDataArray = [];
           this.roles.forEach(role =>{
            noDataArray.push({
              "ID": null,
              "RoleID": role['RoleID'],
              "PermissionID": element['ID'],
              "PermissionValue": 0,
              "created_at": "",
              "updated_at": ""
            })
           });
           formattedArray[index] = noDataArray;
      
      } else {

        formattedArray.push(permissinonExistArray) 
      }
    });
    return formattedArray;
	}


  // Select or Deselect Permission
  selectPermission(ev,permission){
    const checked = ev.target ? ev.target.checked : ev.checked;
    permission.PermissionValue = checked ? 1 : 0;
    const index = this.permissionDataToSave.findIndex(data =>data.PermissionId === permission.PermissionID && data.RoleId === permission.RoleID);
    if (index >= 0) {
      this.permissionDataToSave.splice(index,1);
    }
     this.permissionDataToSave.push({
         'ID':permission.ID,
        'RoleId' :permission.RoleID,
        'PermissionId' : permission.PermissionID,
        'Checked': checked
        })
    this.setSelectOrDeselectCheckbox();
  }

  savePermission(){
    this.api.post(`savepermissions`,{permissions: this.permissionDataToSave}).subscribe(
			(results: any) => {
        this.getAllPermissions();
        this.setSelectOrDeselectCheckbox();
        this.modalService.showAlert('Success', 'Permission updated created');
        this.log.event(AnalyticEvent.event.systemPermissionAdded);				
			},
			(error: any) => {
				this.log.error('Error loading. ' + error.message);
				this.isLoaded = false;
        this.log.debug('Inside API failure' ,this.isLoaded)
    
			}
		);
  }


  createPermission(){
    const modal = this.modalService.showComponent(CreatePermissionComponent,{
  });
    modal.beforeClosed().subscribe((responseData: any) => {
      if (responseData){
        this.permission = [];
        this.allPermission = [];
        this.getAllPermissions(); 
      }  
    });
  }

  /**
   * Select All Permission
   */
   selectAllPermission(ev,role){
    const checked = ev.target ? ev.target.checked : ev.checked;
    this.allPermission.forEach(permission =>{
      permission.forEach((rolePermission,index) =>{
        if(rolePermission['RoleID'] === role.RoleID) {
          rolePermission['PermissionValue'] = checked ? 1 : 0;
          const existingIndex = this.permissionDataToSave.findIndex(data => data.PermissionId === rolePermission.PermissionID && data.RoleId === rolePermission.RoleID);
          if (existingIndex >= 0) {
            this.permissionDataToSave.splice(existingIndex, 1);
          }
          this.permissionDataToSave.push({
            'ID':rolePermission.ID,
           'RoleId' :rolePermission.RoleID,
           'PermissionId' : rolePermission.PermissionID,
           'Checked': checked
           })
        }
      });
    })
    role['isAllChecked'] = checked;
   }


   setSelectOrDeselectCheckbox(){
     this.roles.forEach(role => {
      const allChecked = this.allPermission.every(permissionRow => {
        const cell = permissionRow.find(perm => perm.RoleID === role['RoleID']);
        return cell && cell.PermissionValue === 1;
      });
      role['isAllChecked'] = allChecked;
     });
   }

   getEnabledCount(roleIndex: number): number {
     let count = 0;
     for (const row of this.allPermission) {
       if (row[roleIndex] && row[roleIndex].PermissionValue === 1) {
         count++;
       }
     }
     return count;
   }
}
